import axios from "axios";
import { BASE_URL } from "../config/apiConfig";

// Use centralized API base URL from .env file
export default axios.create({
  baseURL: BASE_URL,
});
